var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navbar'),_c('div',{attrs:{"sticky":"","id":"demo-warning"}},[_vm._v(" Attention! This is a development / demo version of the kicker-elo website. Entered date may be deleted or get lost at any time ")]),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }